import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

export const TermsOfDeliverySection = () => {
  const t = useTranslations();
  return (
    <>
      <Typography Element="h2" variant="h1">
        {t('terms_delivery_title')}
      </Typography>
      <Typography>
        <em>{t('terms_delivery_last_updated')}</em>
      </Typography>

      <Typography Element="h3" variant="h3">
        {t('terms_delivery_subtitle_canada_uk')}
      </Typography>
      <Typography>{t('terms_delivery_p_canada_uk')}</Typography>

      <Typography Element="h3" variant="h3">
        {t('terms_delivery_subtitle_eu_usa')}
      </Typography>
      <Typography>{t('terms_delivery_p_eu_usa')}</Typography>

      <Typography Element="h3" variant="h3">
        {t('terms_delivery_subtitle_outside')}
      </Typography>
      <Typography>{t('terms_delivery_p_outside')}</Typography>
    </>
  );
};
